// BonBoZ: phân biệt thiết bị có CHUỘT THẬT với thiết bị cảm ứng.
//
// Dùng để quyết định có tự đặt con trỏ vào ô nhập hay không. Trên máy tính, mở
// một bảng chọn ra mà con trỏ nhảy sẵn vào ô tìm kiếm là tiện: tay đang ở bàn
// phím, gõ được ngay. Trên điện thoại thì y hệt hành động đó lại kéo bàn phím
// ảo trồi lên che mất nửa màn hình — che đúng cái bảng vừa mở.
//
// Đo bằng `pointer`/`hover` chứ KHÔNG bằng user-agent hay bề ngang màn hình:
//   - user-agent nói dối, và không nói được người dùng đang cầm chuột hay chạm.
//   - bề ngang màn hình sai ở cả hai đầu: tablet có bàn phím rời thì rộng mà
//     vẫn chạm là chính, còn cửa sổ trình duyệt thu hẹp trên máy tính thì hẹp
//     mà vẫn có chuột.
//
// `pointer: fine` = thiết bị trỏ chính xác (chuột, bút cảm ứng, trackpad).
// `hover: hover` = rê qua được mà không cần bấm. Máy lai vừa có cảm ứng vừa có
// chuột sẽ báo `fine` khi chuột đang là thiết bị chính, đúng điều mình cần.
export const coChuotThat = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(hover: hover) and (pointer: fine)').matches;

// Đặt con trỏ vào ô nhập, nhưng chỉ khi có chuột thật.
//
// Gom thành một hàm để chỗ gọi đọc ra ý định ngay, khỏi lặp lại điều kiện ở mỗi
// nơi rồi sót một chỗ.
export const datConTro = phanTu => {
  if (!coChuotThat()) return false;

  phanTu?.focus?.();
  return true;
};
